angular.module( 'acme.view.application.membership.levels.create.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.levels.create.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipLevelsCreateModalsRemove = {
        name: 'application.membership.levels.create.modals.remove',
        url: '/membership/levels/create/modals/remove',
        views: {
          "main": {
            controller: 'MembershipLevelsCreateModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/levels/create/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipLevelsCreateModalsRemove);
});
